<template>
  <div class="flex flex-col h-full" id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "beta",
  components: {}
};
</script>

<style>
@tailwind base;

@tailwind utilities;

@import "~animate.css/animate.css";
</style>
